module.exports = __webpack_public_path__ + "img/room_standby.a2b837ed.svg";